import i18n from '@/i18n'

export const defaultDialerTableColumns = [
    {
        prop: 'campaignName',
        align: 'center',
        fixed: false,
        label: i18n.global.t('widget.dialerRealTimeTable.column.campaignName'),
        minWidth: 130
    },
    {
        prop: 'campaignType',
        align: 'center',
        fixed: false,
        label: i18n.global.t('widget.dialerRealTimeTable.column.campaignType'),
        minWidth: 130
    },
    {
        prop: 'campaignID',
        align: 'center',
        fixed: false,
        label: i18n.global.t('widget.dialerRealTimeTable.column.campaignID'),
        minWidth: 130
    },
    {
        prop: 'TotalCalls',
        align: 'center',
        fixed: false,
        label: i18n.global.t('widget.dialerRealTimeTable.column.TotalCalls'),
        minWidth: 130
    },
    {
        prop: 'TotalLeg1AnswerCalls',
        align: 'center',
        fixed: false,
        label: i18n.global.t('widget.dialerRealTimeTable.column.TotalLeg1AnswerCalls'),
        minWidth: 130
    },
    {
        prop: 'TotalLeg1RingingCalls',
        align: 'center',
        fixed: false,
        label: i18n.global.t('widget.dialerRealTimeTable.column.TotalLeg1RingingCalls'),
        minWidth: 130
    },
    {
        prop: 'TotalLeg2AnswerCalls',
        align: 'center',
        fixed: false,
        label: i18n.global.t('widget.dialerRealTimeTable.column.TotalLeg2AnswerCalls'),
        minWidth: 130
    },
    {
        prop: 'TotalLeg2RingingCalls',
        align: 'center',
        fixed: false,
        label: i18n.global.t('widget.dialerRealTimeTable.column.TotalLeg2RingingCalls'),
        minWidth: 130
    },
    {
        prop: 'TotalOriginatingCalls',
        align: 'center',
        fixed: false,
        label: i18n.global.t('widget.dialerRealTimeTable.column.TotalOriginatingCalls'),
        minWidth: 130
    },
    {
        prop: 'TotalPendingCalls',
        align: 'center',
        fixed: false,
        label: i18n.global.t('widget.dialerRealTimeTable.column.TotalPendingCalls'),
        minWidth: 130
    },
    {
        prop: 'TypeName',
        align: 'center',
        fixed: false,
        label: i18n.global.t('widget.dialerRealTimeTable.column.TypeName'),
        minWidth: 130
    },
    {
        prop: 'Queue',
        align: 'center',
        fixed: false,
        label: i18n.global.t('widget.dialerRealTimeTable.column.Queue'),
        minWidth: 130
    },
    {
        prop: 'CurrentAwaitingCallers',
        align: 'center',
        fixed: false,
        label: i18n.global.t('widget.dialerRealTimeTable.column.CurrentAwaitingCallers'),
        minWidth: 250
    },
    {
        prop: 'CurrentTotalAgents',
        align: 'center',
        fixed: false,
        label: i18n.global.t('widget.dialerRealTimeTable.column.CurrentTotalAgents'),
        minWidth: 250
    },
    {
        prop: 'CurrentFreeAgents',
        align: 'center',
        fixed: false,
        label: i18n.global.t('widget.dialerRealTimeTable.column.CurrentFreeAgents'),
        minWidth: 250
    }
]
